module.exports = __webpack_public_path__ + "img/james.f8039822.jpg";